<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <h4 class="card-title">Gestion des livreurs</h4>
            </template>
            <l-table class="table-hover table-striped"
                     :columns="table1.columns"
                     :data="table1.data">
            </l-table>
          </card>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Utilisateurs/TableLivreurs.vue'
  import Card from 'src/components/Cards/Card.vue'
  const tableColumns = ['Id', 'Option1', 'Option2', 'Option3', 'Option4']
  const tableData = [{
    id: 1,
    Option1: '........',
    Option2: '........',
    Option3: '........',
    Option4: '........'
  },]

  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        table1: {
          columns: [...tableColumns],
          data: [...tableData]
        },
        table2: {
          columns: [...tableColumns],
          data: [...tableData]
        }
      }
    }
  }
</script>
<style>
</style>
